import React from "react";
import { Routes, Route } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import Navbar from "./components/NavBar";
import Header from "./components/Header";

// Pages
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import CreatePoll from "./pages/CreatePoll";
import ForgotPassword from "./pages/ForgotPassword";
import MyPolls from "./pages/MyPolls";
import Portal from "./pages/Portal";

// Protected wrapper
import ProtectedRoute from "./auth/ProtectedRoute";

function App() {
  const { user } = useAuth();

  return (
    <div className="app-container">
      <header className="app-header">
        <Header />
        <Navbar />
      </header>

      <main className="app-main">
        {user?.token ? (
          <p className="welcome-text">
            Welcome back, {user.email ?? "user"}! Your token is active.
          </p>
        ) : (
          <div className="auth-buttons">
            {/* If you enable these, re-import the components at the top */}
            {/* <GoogleSignIn /> */}
            {/* <AppleSignIn /> */}
          </div>
        )}

        <Routes>
          <Route path="/" element={<p>Welcome to PollChimp</p>} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />

          {/* Protected routes */}
          <Route
            path="/createpoll"
            element={
              <ProtectedRoute>
                <CreatePoll />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mypolls"
            element={
              <ProtectedRoute>
                <MyPolls />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;
